<template>
  <div class="cloud-view">
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-20px">
      <div class="tw-text-textInfo">{{ $t("基本信息") }}</div>
      <div
        class="tw-cursor-pointer tw-text-sm hover:tw-text-primary tw-text-textInfo"
        @click="onBack"
      >
        <b-icon icon="chevron-left"></b-icon>
        <span>{{ $t("返回") }}</span>
      </div>
    </div>

    <!-- 订单详情卡片 -->
    <b-card no-body class="mt-20 pb-10px order-detail-card">
      <!-- 卡片头部 -->
      <b-card-header class="card-header">
        <span class="tw-text-sm">{{ $t("到期时间") }}</span>
        <div class="tw-text-xs">
          <span class="tw-text-textLight tw-mr-1">{{
            parseTime(item.expirationDate)
          }}</span>
          <span class="term-spread">({{ $t("到期") }})</span>
        </div>
      </b-card-header>

      <!-- 内容区域 -->
      <b-card-body>
        <ul class="tw-grid lg:tw-grid-cols-5 tw-gap-2 tw-grid-cols-1">
          <li
            class="tw-flex lg:tw-flex-col tw-flex-row tw-items-center tw-justify-between tw-text-center lg:tw-px-4 lg:tw-py-4"
          >
            <div class="tw-px-2 tw-py-2 tw-text-sm tw-text-textMain info-label">
              {{ $t("产品名称") }}
            </div>
            <div
              class="tw-px-2 tw-py-2 tw-text-sm tw-text-textInfo tw-font-bold info-value"
            >
              {{ item.productName }}
            </div>
          </li>
          <li
            class="tw-flex lg:tw-flex-col tw-flex-row tw-items-center tw-justify-between tw-text-center lg:tw-px-4 lg:tw-py-4"
          >
            <div class="tw-px-2 tw-py-2 tw-text-sm tw-text-textMain info-label">
              {{ $t("实例ID") }}
            </div>
            <div
              class="tw-px-2 tw-py-2 tw-text-sm tw-text-textInfo tw-font-bold info-value"
            >
              {{ item.id }}
            </div>
          </li>
          <li
            class="tw-flex lg:tw-flex-col tw-flex-row tw-items-center tw-justify-between tw-text-center lg:tw-px-4 lg:tw-py-4"
          >
            <div class="tw-px-2 tw-py-2 tw-text-sm tw-text-textMain info-label">
              {{ $t("支付时间") }}
            </div>
            <div
              class="tw-px-2 tw-py-2 tw-text-sm tw-text-textInfo tw-font-bold info-value"
            >
              {{ parseTime(item.payTime) }}
            </div>
          </li>

          <li
            class="tw-flex lg:tw-flex-col tw-flex-row tw-items-center tw-justify-between tw-text-center lg:tw-px-4 lg:tw-py-4"
          >
            <div class="tw-px-2 tw-py-2 tw-text-sm tw-text-textMain info-label">
              {{ $t("开通时间") }}
            </div>
            <div
              class="tw-px-2 tw-py-2 tw-text-sm tw-text-textInfo tw-font-bold info-value"
            >
              {{ parseTime(item.launchTime) }}
            </div>
          </li>
          <li
            class="tw-flex lg:tw-flex-col tw-text-sml tw-flex-row tw-items-center tw-justify-between tw-text-center lg:tw-px-4 lg:tw-py-4"
            v-for="(im, ix) in infoList"
            :key="ix"
          >
            <div class="tw-px-2 tw-py-2 tw-text-textMain info-label">
              {{ im.name }}
            </div>
            <div
              class="tw-px-2 tw-py-2 tw-text-sm tw-text-textInfo tw-font-bold info-value"
            >
              {{ im.value }}
            </div>
          </li>
        </ul>
      </b-card-body>
    </b-card>
    <div class="tw-text-textInfo mt-20">
      {{ $t("实例概况") }}
    </div>
    <div class="tw-flex tw-flex-wrap tw-justify-between tw-items-center">
      <div>
        <div class="tw-flex tw-flex-wrap tw-items-center">
          <span class="tw-mr-10 lg:tw-mt-0 tw-mt-5 tw-text-sm"
            >{{ $t("运行状态") }}：</span
          >
          <b-form-group class="lg:tw-mt-5 tw-mt-2.5 tw-text-sm">
            <b-form-checkbox-group
              v-model="selectedStatus"
              :options="statusOptions"
              stacked
              class="tw-flex lg:tw-gap-6 tw-gap-4"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
        <div v-if="isExpiringSoon" class="tw-flex tw-items-center">
          <span class="tw-mr-20 tw-text-textMain tw-text-sm"
            >{{ $t("到期提示") }}：</span
          >

          <span class="about-expire tw-text-sm tw-rounded-md">{{
            $t("即将到期")
          }}</span>
        </div>
      </div>

      <b-button variant="primary" class="but-text" @click="renewOrder">{{
        $t("续费")
      }}</b-button>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils/ruoyi";
export default {
  name: "cloud-view",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      parseTime,
      // 当前选中的状态
      selectedStatus: [1],
      // 状态选项
      statusOptions: [
        {
          value: 1,
          text: "运行中",
          disabled: true,
        },
        {
          value: 2,
          text: "已停止",
          disabled: true,
        },
        {
          value: 3,
          text: "已过期 ",
          disabled: true,
        },
        {
          value: 4,
          text: "创建中",
          disabled: true,
        },
      ],
      infoList: [],
    };
  },
  computed: {
    isExpiringSoon() {
      if (!this.item.expirationDate) {
        return false;
      }

      const expirationTime = new Date(this.item.expirationDate).getTime();
      const currentTime = new Date().getTime();

      const timeDiff = expirationTime - currentTime;

      const daysDiff = timeDiff / (1000 * 60 * 60 * 24);

      return daysDiff <= 7 && daysDiff >= 0;
    },
  },
  created() {
    this.infoList = this.item.sku[0].extras;
    this.selectedStatus[0] = this.item.status;
  },
  methods: {
    // 方法区
    // 续费
    renewOrder() {
      localStorage.setItem("currentItem", JSON.stringify(this.item));
      this.$store.commit("SET_ORDERTYPE", "cloud-renewed");
      this.$store.commit("SET_CURRENTSTEP", "confirm");
      this.$router.push({
        path: "/controlCenter/renewal-management",
      });
    },
    // 返回
    onBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  background-color: #ecf2ff;
  padding: 9px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}
.term-spread {
  color: #ff4e4e;
}
.card-body {
  padding: 0;
}
.about-expire {
  padding: 4px 8px;
  background-color: #ff4e4e;
  color: #fff;
  font-size: 12px;
}
.but-text {
  padding: 10px 40px;
  box-sizing: border-box;
  // border-radius: 0;
}

@media (max-width: 768px) {
  .card-header {
    padding: 9px 15px;
  }
}
</style>
